import React from "react";
import "./Footer.css";
import useLang from "../hooks/useLang";
import { CONFIG } from "../config";

const Footer = () => {
	const currentYear = new Date().getFullYear();
	const { strings } = useLang("footer");

	return (
		<>
			<div className="footerContainer">
				<div className="mainFooter">
					<p>
						2024 &copy; Postman - {strings?.description}{" "}
						{CONFIG?.APPVERSION}
					</p>
				</div>
			</div>
		</>
	);
};

export default Footer;
